var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "result-hero",
      style: { "background-image": _vm.backgroundImage }
    },
    [
      _c("div", { staticClass: "result-hero__wrapper" }, [
        _c(
          "div",
          { staticClass: "result-hero__location" },
          [_c("location-info", { attrs: { data: _vm.locationInfo } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("order-progress", { attrs: { step: 1 } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03cceb3a", { render: render, staticRenderFns: staticRenderFns })
  }
}